export const boxComponentStyle = {
  backgroundColor: "#fff",
  boxShadow:
    "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
  p: 3,
  mb: 3,
  borderRadius: "5px",
};

export const boxChildComponent = {
  backgroundColor: "#fff",
  boxShadow:
    "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
  px: 3,
  py: 2,
  borderRadius: "5px",
};
